import { forwardRef } from 'react';
import { FormikProps } from 'formik';
import styled from '@emotion/styled';
import { FormValues } from '@selfserve/react-hooks';

import { CheckoutBillingForm } from './checkout-billing-form';
import { CheckoutPaymentForm } from './checkout-payment-form';
import { cardFormTypes } from '@selfserve/react-utils';

const StyledContainer = styled('div')(({ theme }: { theme?: any }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '540px',
  },
}));

interface Props {
  formik: FormikProps<FormValues>;
  handleDropdownChange: (name: string) => (value: string) => void;
  handleCardInputsChange: (field: any) => void;
  handleCardInputsBlur: (field: any) => void;
  handleZipCodeBlur?: () => void;
  reverse?: boolean;
  activeFormSection?: string;
}

const checkoutFormContent = (
  props: Props,
  ref: React.ForwardedRef<unknown>,
  reverse?: boolean
) => {
  switch (props.activeFormSection) {
    case cardFormTypes.EDIT_BILLING_INFO:
      return <CheckoutBillingForm {...props} />;
    case cardFormTypes.CHANGE_PAYMENT_METHOD:
      return <CheckoutPaymentForm {...props} ref={ref} />;
    default:
      return reverse ? (
        <>
          <CheckoutPaymentForm {...props} ref={ref} />
          <CheckoutBillingForm {...props} />
        </>
      ) : (
        <>
          <CheckoutBillingForm {...props} />
          <CheckoutPaymentForm {...props} ref={ref} />
        </>
      );
  }
};

export const CheckoutForm = forwardRef((props: Props, ref) => (
  <StyledContainer>
    {checkoutFormContent(props, ref, props.reverse)}
  </StyledContainer>
));
